module.exports = __webpack_public_path__ + "img/success.bd77d96d.png";